"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var classnames_1 = require("classnames");
var react_lazyload_1 = require("react-lazyload");
var Image_1 = require("../../common/Image");
var styles = require("./index.scss");
var banner_1 = require("utils/playground/banner");
var WithPrm_1 = require("components/WithPrm");
var prm_1 = require("utils/prm");
var Carousel = (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangePosition = function (type) { return function () {
            var current = _this.state.current;
            var banners = _this.props.banners;
            var max = banners.length - 1;
            if (type === "left") {
                _this.setState({
                    current: current > 0 ? current - 1 : max
                });
            }
            if (type === "right") {
                _this.setState({
                    current: current < max ? current + 1 : 0
                });
            }
        }; };
        _this.renderBody = function () {
            var _a = _this.props, className = _a.className, style = _a.style, banners = _a.banners, showArrow = _a.showArrow, showDots = _a.showDots;
            var current = _this.state.current;
            if (banners.length <= 1) {
                showDots = false;
                showArrow = false;
            }
            return (React.createElement("div", { style: style, className: styles.carouselWrapper + " " + className, onMouseEnter: function () { return _this.setState({ pause: true }); }, onMouseLeave: function () { return _this.setState({ pause: false }); } },
                React.createElement("ul", { className: styles.carouselList, style: {
                        width: banners.length * 100 + "%",
                        transform: "translateX(-" + (100 / banners.length) * current + "%)"
                    } }, banners.map(function (item, index) {
                    var link = _this.genLinkByUrl(item.link, index + 1);
                    return (React.createElement("li", { key: index },
                        React.createElement("a", { "data-href": link, href: link || "javascript:void", target: "_blank" },
                            React.createElement(Image_1.default, { key: item.img, src: smartimagesrc_1.makeImageUrls(item.img, {
                                    online: true,
                                    qnParams: { w: 1440 },
                                    keepSize: true,
                                    aliSize: 14.4
                                })[0] || item.img, defaultSrc: banner_1.GetEmptyImage(), params: "imageView2/2/w/1440", aliSize: 14.4 }))));
                })),
                showArrow && [
                    React.createElement("i", { key: "left", onClick: _this.onChangePosition("left"), className: styles.leftBtn }),
                    React.createElement("i", { key: "right", onClick: _this.onChangePosition("right"), className: styles.rightBtn })
                ],
                showDots && (React.createElement("ul", { className: styles.dots }, banners.map(function (_, index) { return (React.createElement("li", { onClick: function () { return _this.setState({ current: index }); }, className: index === current ? styles.active : "", key: index })); })))));
        };
        _this.state = {
            current: 0,
            pause: false
        };
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        var _this = this;
        var banners = this.props.banners;
        if (banners.length <= 1) {
            return;
        }
        setInterval(function () {
            var current = _this.state.current;
            if (_this.state.pause) {
                return;
            }
            _this.setState({
                current: current === banners.length - 1 ? 0 : current + 1
            });
        }, 3000);
    };
    Carousel.prototype.genLinkByUrl = function (url, order) {
        var tprm = this.props.tprm;
        return prm_1.genPrmLink(url, __assign(__assign({}, tprm), { position: order }));
    };
    Carousel.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, positionIndex = _b.positionIndex;
        return (React.createElement("div", { id: id, className: classnames_1.default(styles.banner, (_a = {}, _a[styles.adorBanner] = true, _a)) }, positionIndex < 4 ? (React.createElement(React.Fragment, null, this.renderBody())) : (React.createElement(react_lazyload_1.default, { offset: 100, height: window.innerHeight }, this.renderBody()))));
    };
    Carousel.defaultProps = {
        showDots: true,
        showArrow: false
    };
    return Carousel;
}(React.Component));
exports.default = WithPrm_1.default(Carousel);
